<template>
	<div class="followup-container">
		<div class="followup-header">
			<el-col :span="20">
			</el-col>
			<el-col :span="4">
				<el-button type="primary" @click="$emit('add-followup')">
					<el-icon>
						<Plus />
					</el-icon> 添加跟进记录
				</el-button>
			</el-col>
		</div>
		<div class="contacts-section height">
			<el-timeline>
				<el-timeline-item v-for="(record, index) in records" :key="index"
					:timestamp="formatDateTime(record.createTime)" :type="getFollowupType(record.type)"
					:hollow="record.type === 'other'" :color="getFollowupColor(record.type)" placement="top">
					<el-card shadow="hover">
						<template #header>
							<div class="followup-header">
								<span class="followup-title">{{ record.subject }}</span>
								<el-tag size="small" :type="getFollowupType(record.type)">
									{{ getFollowupTypeText(record.type) }}
								</el-tag>
							</div>
						</template>
						<div class="followup-content">
							<el-row :gutter="20">
								<el-col :span="12">
									跟进人：{{ record.username }}
								</el-col>
								<el-col :span="12">
									时间：{{ formatDateTime(record.startTime) }} -
									{{ formatDateTime(record.endTime) }}
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									地点：{{ record.location || '未设置' }}
								</el-col>
								<el-col :span="12">
									<text v-if="record.lng && record.lat">
										坐标：{{ record.lng }}, {{ record.lat }}
									</text>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="20">
									<h4>跟进内容：</h4>
									<p>{{ record.notes }}</p>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="20">
									<h4>相关图片：</h4>
									<el-image v-for="(photo, photoIndex) in record.photos" :key="photoIndex"
										:src="photo" :preview-src-list="record.photos" fit="cover"
										class="followup-photo" />
								</el-col>
							</el-row>
						</div>
					</el-card>
				</el-timeline-item>
			</el-timeline>
		</div>
	</div>
</template>

<script>
	export default {
		name: "BusActivities",
		props: {
			records: {
				type: Array,
				required: true,
				default: () => []
			}
		},
		methods: {
			formatDateTime(date) {
				// 这里实现你的日期格式化逻辑
				return date // 示例，请替换为实际格式化代码
			},
			getFollowupType(type) {
				// 返回对应的类型，如 'primary', 'success' 等
				const typeMap = {
					call: 'primary',
					meeting: 'success',
					other: 'info'
				}
				return typeMap[type] || 'info'
			},
			getFollowupColor(type) {
				// 返回对应的颜色
				const colorMap = {
					call: '#409EFF',
					meeting: '#67C23A',
					other: '#909399'
				}
				return colorMap[type] || '#909399'
			},
			getFollowupTypeText(type) {
				// 返回对应的类型文本
				const textMap = {
					call: '电话',
					meeting: '会议',
					other: '其他'
				}
				return textMap[type] || '其他'
			}
		}
	}
</script>

<style scoped>
	.el-row {
		margin-bottom: 12px;

		&:last-child {
			margin-bottom: 0;
		}
	}
</style>